import { render, staticRenderFns } from "./rh-domicilio-card.vue?vue&type=template&id=08b15eb8&scoped=true"
import script from "./rh-domicilio-card.vue?vue&type=script&lang=js"
export * from "./rh-domicilio-card.vue?vue&type=script&lang=js"
import style0 from "./rh-domicilio-card.vue?vue&type=style&index=0&id=08b15eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b15eb8",
  null
  
)

export default component.exports